import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect, withRouter } from 'react-router-dom';
import RequiresAuth from 'components/auth/RequiresAuth';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import Content from 'components/Content';
import AssetThumbnail from 'components/common/AssetThumbnail';
import CardForm from 'components/order/CardForm';
/* import PaypalForm from 'components/order/PaypalForm'; */
import SavedPaymentInfo from 'components/order/SavedPaymentInfo';
import Summary from 'components/order/Summary';
import InteractionOverlay from 'components/order/InteractionOverlay';
import * as orderActions from 'actions/order';
import * as bundleActions from 'actions/bundles';
import ReCAPTCHA from 'react-google-recaptcha';

import bundleImg from 'images/ultimate/mt-ut-img-1.png';

import classNames from 'classnames';

import './Order.scss';

const fbq = window.fbq;

export class OrderUltimate extends Component {
  componentDidMount() {
    const { location, checkCaptcha } = this.props;
    if (location.search === '?f') {
      fbq('track', 'PageView');
      fbq('track', 'CheckoutDoodlyUltimate');
    }

    this.props.clearCurrentBundle();
    checkCaptcha(); // clear previous captcha validations
  }

  handlePaymentMethodChange = (event, method) => {
    event.preventDefault();
    this.props.changePaymentMethod(method);
  };

  handleToogleSavedInfo = event => {
    event.preventDefault();
    this.props.toggleSavedPaymentInfo();
  };

  handlePaymentMethodTokenization = paymentInfo => {
    const { purchaseUltimate, location } = this.props;

    if (location.search === '?f') {
      paymentInfo = {
        ...paymentInfo,
        product_id: '41439'
      };
    }

    purchaseUltimate(paymentInfo);
  };

  purchaseUsingSavedPaymentInfo = () => {
    const { captchaSuccessful, purchaseUltimate, location } = this.props;
    if (!captchaSuccessful) {
      alert('Please complete the captcha challenge in order to continue.');
      return;
    }

    let paymentInfo = {};
    if (location.search === '?f') {
      paymentInfo = {
        product_id: '41439'
      };
    }

    purchaseUltimate(paymentInfo);
  };

  render() {
    const {
      savedPaymentInfo,
      purchaseSuccessful,
      useSavedPaymentInfo,
      isProcessing,
      useCreditCard,
      reset,
      checkCaptcha
    } = this.props;

    if (purchaseSuccessful) {
      reset();
      return <Redirect to="/my_purchases" />;
    }

    return (
      <div className="order">
        <RequiresAuth />
        <Header />
        <Content>
          <div className="breadcrumbs">
            <Link to="/">Home</Link>
            <span className="sep">&gt;</span>
            Doodly Marketplace Ultimate
          </div>

          <div className="sheet">
            <div className="row">
              <div className="col-md-5 info">
                <AssetThumbnail className="large thumb" image={bundleImg} style={{ backgroundSize: 'contain' }} />
                <h2>Doodly Marketplace Ultimate</h2>
                <div className="description">
                  Doodly Marketplace Ultimate consists of all 126 bundles sold on Doodly Marketplace -- a total of 111
                  standard bundles (Normally $27 a piece) and 15 premium bundles (Normally $37 a piece).
                </div>
              </div>
              <div className="col-md-7">
                <div className="payment-info">
                  <h3>Payment Information</h3>
                  {useSavedPaymentInfo ? (
                    <>
                      {savedPaymentInfo && (
                        <div className="payment-option saved p-4">
                          <SavedPaymentInfo {...savedPaymentInfo} />
                          <hr />
                          <a href="/" onClick={event => this.handleToogleSavedInfo(event)}>
                            Use different payment information
                          </a>
                          <Summary bundleType="ultimate" className="mt-4" />
                          <div className="d-flex justify-content-between mt-4">
                            <ReCAPTCHA
                              sitekey="6LeOVrEUAAAAACN_W6Jz43aRUH0eraIqB35XnYAK"
                              onChange={token => checkCaptcha(token)}
                            />
                            <button className="btn btn-green" onClick={() => this.purchaseUsingSavedPaymentInfo()}>
                              {isProcessing ? 'Processing...' : 'Buy Now'}
                            </button>
                          </div>
                          <InteractionOverlay active={isProcessing} />
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="new">
                      {savedPaymentInfo && (
                        <>
                          <a href="/" onClick={event => this.handleToogleSavedInfo(event)}>
                            Use saved payment information
                          </a>
                          <hr />
                        </>
                      )}
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            href="/"
                            className={classNames('btn-link nav-link', { active: useCreditCard })}
                            onClick={event => this.handlePaymentMethodChange(event, 'credit_card')}
                          >
                            Credit Card
                          </a>
                        </li>
                        {/* <li className="nav-item">
                          <button
                            href="/"
                            className={classNames('btn-link nav-link', { active: usePaypal })}
                            onClick={event => this.handlePaymentMethodChange(event, 'paypal')}
                          >
                            Paypal
                          </button>
                        </li> */}
                      </ul>
                      {useCreditCard && (
                        <CardForm
                          bundleType="ultimate"
                          onTokenization={data => this.handlePaymentMethodTokenization(data)}
                        />
                      )}
                      {/* {usePaypal && (
                        <PaypalForm
                          bundleType="ultimate"
                          onTokenization={data => this.handlePaymentMethodTokenization(data)}
                        />
                      )} */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Content>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { user, order } = state;
  const { useSavedPaymentInfo, isProcessing, useCreditCard, purchaseSuccessful, captchaSuccessful } = order;
  return {
    savedPaymentInfo: user.paymentInfo,
    useSavedPaymentInfo,
    isProcessing,
    useCreditCard,
    purchaseSuccessful,
    captchaSuccessful
  };
};

const mapDispatchToProps = dispatch => ({
  clearCurrentBundle: () => dispatch(bundleActions.clearCurrentBundle()),
  changePaymentMethod: method => dispatch(orderActions.changePaymentMethod(method)),
  toggleSavedPaymentInfo: () => dispatch(orderActions.toggleSavedPaymentInfo()),
  purchaseUltimate: paymentInfo => dispatch(orderActions.asyncOrderUltimate(paymentInfo)),
  reset: () => dispatch(orderActions.reset()),
  checkCaptcha: token => dispatch(orderActions.asyncCheckCaptcha(token))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OrderUltimate));
